import { createContext } from 'react';
import { SeoBlockContextType } from './SeoBlockContextType';

const SeoBlockContext = createContext<SeoBlockContextType|null>(null);

export { SeoBlockContext };
